import cookieNames from './cookieNames'


const specialFlowCookies = [
  { name: cookieNames.offer },
  { name: cookieNames.fbPixel },
  { name: cookieNames.giftCoupon },
  { name: cookieNames.userGender },
  { name: cookieNames.selectedPlan },
  { name: cookieNames.discountCoupon },
  { name: cookieNames.isFreeTrialCoupon },
  { name: cookieNames.isFreeTrialOrgFlow },
  { name: cookieNames.specialFlowName, options: { maxAge: 0 } },
  { name: cookieNames.priceWithDiscount, options: { encode: false } },
  { name: cookieNames.referrerLandingPageURL, options: { encode: false }, withEncode: true },
]


export default specialFlowCookies
